import { confirm, loading, throttle, validate } from '@/commons/decorators/decorator';
import { Hospital } from '@/entities/hospital';
import { PhysicalInfo } from '@/entities/physical';
import { MARITAL_STATUS } from '@/metas/user';
import physicalService from '@/services/physical.services';
import { UserModule } from '@/store/modules/user';
import HospitalFiles from '@/views/form/hospital.files.vue';
import _ from 'lodash';
import { Field, Form, ImagePreview } from 'vant';
import { Component, Vue, Watch } from 'vue-property-decorator';

/**
 * 申请表单
 */
@Component({
    name: 'ApplicationForm',
    components: {
        HospitalFiles,
    },
})
export default class extends Vue {
    public $refs!: { form: Form };

    // 体检信息
    public physicalInfo: PhysicalInfo | null = null;

    // 选择的医院id
    public selectHospital: Hospital | null = null;

    // 医院弹框可见
    public hospitalPopupVisible: boolean | null = false;

    public loading: boolean = false;

    public MARITAL_STATUS = MARITAL_STATUS;

    // 本年度已选择
    public thisYearSelected: boolean = false;

    // 所选医院体检额度
    public amount: number | null = null;

    /**
     * 确认选择医院
     */
    public async handleSelectHospital(hospital: Hospital) {
        this.selectHospital = hospital;
        this.hospitalPopupVisible = false;
    }

    @Watch('selectHospital.hospitalId')
    public async getAmount() {
        if (!this.selectHospital) { return; }
        const res = await physicalService.getAmountByHospitalId(this.selectHospital.hospitalId);
        if (Number(res.message) >= 0) { this.amount = res.message; } else { this.$notify({ type: 'danger', message: res.message, duration: 3000 }); }
    }

    @loading()
    public created() {
        if (UserModule.pageScrollTop) {
            this.$nextTick(() => {
                window.setTimeout(() => {
                    (document.querySelector('html') as HTMLElement).scrollTop = UserModule.pageScrollTop;
                }, 300);
            });
        }
        this.getUserInfo();
        this.$nextTick(() => {
            window.setTimeout(() => {
                (document.querySelector('html') as HTMLElement).addEventListener('scroll', this.scrolling);
                (document.querySelector('html') as HTMLElement).addEventListener('mousewheel', this.scrolling);
            }, 300);
        });
    }

    public destroyed() {
        UserModule.SET_PAGE_SCROLL_TOP(0);
        ((document.querySelector('html') as HTMLElement) as HTMLElement).removeEventListener('scroll', this.scrolling);
        (document.querySelector('html') as HTMLElement).removeEventListener('mousewheel', this.scrolling);
    }

    @throttle(300)
    public scrolling() {
        // @ts-ignore
        const scrollTop = (document.querySelector('html') as HTMLElement).scrollTop;
        UserModule.SET_PAGE_SCROLL_TOP(scrollTop);
    }

    /**
     * 获取用户信息 医院信息
     */
    public async getUserInfo() {
        this.physicalInfo = await physicalService.getInfo();
        if (this.physicalInfo && this.physicalInfo.hospitalNameOfThisYear && this.physicalInfo.hospitals) {
            const selectHospital = this.physicalInfo.hospitals.find(hospital => hospital.hospitalName === this.physicalInfo?.hospitalNameOfThisYear);
            if (selectHospital) {
                this.thisYearSelected = true;
                this.selectHospital = selectHospital;
                document.title = '修改体检医院';
            } else {
                document.title = '选择体检医院';
            }
        }
    }

    /**
     * 验证表单
     */
    public async validate() {
        try {
            await (this.$refs.form as Form).validate();
            return true;
        } catch (e) {
            return false;
        }
    }

    /**
     * 提交申请单表单
     */
    @throttle(2000)
    @validate('validate')
    public async formSubmit() {
        if (!(this.physicalInfo && this.physicalInfo.userInfo.confirm)) {
            this.$notify({ type: 'danger', message: '请先确认个人信息', duration: 3000 });
            return false;
        }
        this.loading = true;
        this.$notify.clear();
        setTimeout(async () => {
            if (this.selectHospital) {
                try {
                    if (this.physicalInfo && this.physicalInfo.hospitalNameOfThisYear === this.selectHospital.hospitalName) {
                        this.$notify({ type: 'success', message: document.title + '成功', duration: 1000 });
                        window.setTimeout(() => {
                            this.$router.replace('/appointment');
                        }, 1000);
                    } else {
                        const formData = {
                            hospitalId: this.selectHospital.hospitalId,
                            hospitalChanged: this.selectHospital.hospitalName === this.physicalInfo?.hospitalNameOfLastYear ? 0 : 1,
                        };
                        const res = await physicalService.physicalOrder(formData);
                        this.$notify({ type: 'success', message: document.title + '成功', duration: 1000 });
                        this.loading = false;
                        window.setTimeout(() => {
                            this.$router.replace('/appointment');
                        }, 1000);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        }, 200);
    }

    public beforeDestroy() {
        // this.$notify.clear();
    }
}
